import { useVisibilityState } from '@lbcamden/lib-react';
import { useCallback, useState } from 'react';

import { PcfraPerson } from '~/common/types/people';

import { UnnecessaryStatusDialog } from './UnnecessaryStatusDialog';

export const useUnnecessaryStatusDialog = () => {
  const [person, setPerson] = useState<PcfraPerson>();
  const [draftId, setDraftId] = useState<string>();

  const { show, hide, visible } = useVisibilityState();

  const showUnnecessaryStatusDialog = useCallback(
    (selectedPerson: PcfraPerson, personDraftId?: string) => {
      setPerson(selectedPerson);
      setDraftId(personDraftId);
      show();
    },
    [],
  );

  return {
    showUnnecessaryStatusDialog,
    unnecessaryStatusDialog: (
      <UnnecessaryStatusDialog open={visible} person={person} draftId={draftId} onClose={hide} />
    ),
  };
};
